import { render } from "./CreateAd.vue?vue&type=template&id=45e21fbb&ts=true"
import script from "./CreateAd.vue?vue&type=script&lang=ts"
export * from "./CreateAd.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__